import CreditCardIcon from './CreditCardIcon'

export default CreditCardIcon
